import React, { Component } from "react";
import { withRouter } from "react-router";
import { Avatar, Tooltip } from "antd";
import { Spring, config } from "react-spring";

const url = "https://d1wumrtbuo797i.cloudfront.net/";

class SubcategorySelection extends Component {
  state = { hover: false };

  renderCategories = () => {
    const { hover } = this.state;
    let { selection } = this.props;
    const { categories, toggleSelection } = this.props;
    selection = selection ? selection.split(",") : [];
    const output = categories.map(({ category, id, thumb, count, realCount, children }, index) => {
      const color = !selection.length || selection.includes(id.toString()) ? "#fff" : "#656565";
      const tooltipText = !selection.length ? "Show only" : color === "#656565" ? "Show" : "Hide";
      return (
        <Spring
          key={category + id}
          config={config.molasses}
          to={{
            top: hover === index ? "-0.5em" : "0em",
            scale: hover === index ? 0.95 : 1,
          }}
          toggle={hover} // Additional props will be spread over the child
        >
          {({ top }) => (
            <Tooltip placement="bottom" title={`${tooltipText} ${category}`}>
              <div
                role="menuitem"
                onMouseEnter={e => this.setState({ hover: index })}
                onMouseLeave={e => this.setState({ hover: -1 })}
                onClick={e => toggleSelection(id)}
                style={{
                  // transform: `scale(${scale})`,
                  transform: `translate(0px,${top})`,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  border: `${color} 1px solid`,
                  borderRadius: "4px",
                  fontSize: "1.5em",
                  margin: ".5em",
                  cursor: "pointer",
                  padding: "0.5em",
                }}
                selected
              >
                <Avatar shape="square" src={url + thumb} size={100} />
                {`${category}(${(index === 0 && children ? realCount : count) || 0})`}
              </div>
            </Tooltip>
          )}
        </Spring>
      );
    });
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginTop: "0.5em",
        }}
      >
        {output}
      </div>
    );
  };

  render() {
    return this.renderCategories();
  }
}
export default withRouter(SubcategorySelection);



// WEBPACK FOOTER //
// ./src/components/gallery/SubcategorySelection.js